module.exports = __webpack_public_path__ + "static/img/news2.c875295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news2.jpg
// module id = b6pe
// module chunks = 1